import { MutationTree } from "vuex";
import { syncState, ISyncSystem, IServerTypes, ITaskDynamicDataTypes, ISyncEntry, ISyncType } from "./types";
import Vue from "vue";
import { getDefaultState } from "./state";

export const mutations: MutationTree<syncState> = {
	setSyncSystems(state, syncSystems: ISyncSystem[]) {
		state.syncSystemPageIndex > 1 ? state.syncSystem.push(...syncSystems) : (state.syncSystem = syncSystems);
	},
	setQueriedSyncSystems(state, syncSystems: ISyncSystem[]) {
		state.syncSystemFilteredPageIndex > 1
			? state.syncSystemFiltered.push(...syncSystems)
			: (state.syncSystemFiltered = syncSystems);
	},
	resetQueriedSyncSystems(state) {
		state.syncSystemFiltered = [];
	},
	setSyncSystemPageNumber(state, syncSystemPageNumber: number) {
		state.syncSystemPageIndex = syncSystemPageNumber;
	},
	setSyncSystemPageSize(state, syncSystemPageSize: number) {
		state.syncSystemPageSize = syncSystemPageSize;
	},
	setSyncSystemFilter(state, syncSystemFilter: string) {
		state.syncSystemFilter = syncSystemFilter;
	},
	setSyncSystemsIsBusyState(state, isBusy: boolean) {
		state.syncSystemsIsBusy = isBusy;
	},
	updateSyncSystem(state, updateSyncSystem: ISyncSystem) {
		const index = state.syncSystem.findIndex(
			(item: ISyncSystem) => item.syncSystemId === updateSyncSystem.syncSystemId
		);

		if (index >= 0) {
			Vue.set(state.syncSystem, index, updateSyncSystem);
		}
	},
	addNewSyncSystem(state, syncSystem: ISyncSystem) {
		if (state.syncSystem.findIndex((x: ISyncSystem) => x.syncSystemId == syncSystem.syncSystemId) == -1) {
			state.syncSystem.push(syncSystem);
		}
	},
	removeSyncSystem(state, syncSystemId: number) {
		const index = state.syncSystem.findIndex((item: ISyncSystem) => item.syncSystemId === syncSystemId);
		state.syncSystem.splice(index, 1);
	},
	setServerYypesWithCanSync(state, serverTypesWithCanSync: IServerTypes[]) {
		state.serverTypesCanSync = serverTypesWithCanSync;
	},
	setSyncSystemsAtEndStatus(state, atEnd: boolean) {
		state.syncSystemsAtEnd = atEnd;
	},
	setSyncSystemFilteredPageIndex(state, index: number) {
		state.syncSystemFilteredPageIndex = index;
	},
	setDynamicDataList(state, dynamicDataList: ITaskDynamicDataTypes[]) {
		state.dynamicDataList = dynamicDataList;
	},

	// Sync Entries
	setSyncEntries(state, syncEntries: ISyncEntry[]) {
		state.syncEntryPageIndex > 1 ? state.syncEntries.push(...syncEntries) : (state.syncEntries = syncEntries);
	},
	setSyncTypes(state, syncTypes: ISyncType[]) {
		state.syncTypes = syncTypes;
	},
	setSyncEntryPageNumber(state, index: number) {
		state.syncEntryPageIndex = index;
	},
	setSyncEntryAtEndStatus(state, atEnd: boolean) {
		state.syncEntryAtEnd = atEnd;
	},
	setSyncEntryIsBusyState(state, isBusy: boolean) {
		state.syncEntryIsBusy = isBusy;
	},
	addNewSyncEntry(state, syncEntry: ISyncEntry) {
		if (syncEntry.enabled && !syncEntry.lastUpdated) {
			state.requiredSyncEntriesStatusChecked.push(syncEntry);
		}
		state.syncEntries.push(syncEntry);
	},
	removeSyncEntry(state, groupSyncId: number) {
		const index = state.syncEntries.findIndex(item => item.groupSyncId === groupSyncId);

		const StatusEntryIndex = state.requiredSyncEntriesStatusChecked.findIndex(x => x.groupSyncId == groupSyncId);
		if (StatusEntryIndex >= 0) {
			state.requiredSyncEntriesStatusChecked.splice(StatusEntryIndex, 1);
		}

		state.syncEntries.splice(index, 1);
	},
	updateSyncEntry(state, syncEntry: ISyncEntry) {
		const index = state.syncEntries.findIndex((se: ISyncEntry) => se.groupSyncId === syncEntry.groupSyncId);

		if (syncEntry.enabled && !syncEntry.lastUpdated) {
			state.requiredSyncEntriesStatusChecked.push(syncEntry);
		}
		if (!syncEntry.enabled) {
			const statusCheckIndex = state.requiredSyncEntriesStatusChecked.findIndex(
				(entry: ISyncEntry) => entry.groupSyncId == syncEntry.groupSyncId
			);
			if (statusCheckIndex >= 0) {
				state.requiredSyncEntriesStatusChecked.splice(statusCheckIndex, 1);
			}
		}

		if (index >= 0) {
			Vue.set(state.syncEntries, index, syncEntry);
		}
	},
	updateSyncEntriesStatus(state, syncEntries: ISyncEntry[]) {
		const updateSyncEntry = (syncEntries: ISyncEntry[], entry: ISyncEntry): void => {
			const entryIndex: number = syncEntries.findIndex(
				(syncEntry: ISyncEntry) => syncEntry.groupSyncId == entry.groupSyncId
			);

			if (entryIndex >= 0) {
				entry.syncSystemTitle = syncEntries[entryIndex].syncSystemTitle;
				Vue.set(syncEntries, entryIndex, entry);
			}
		};

		syncEntries.forEach((entry: ISyncEntry) => {
			const findIndex = state.requiredSyncEntriesStatusChecked.findIndex(
				(EntryStatus: ISyncEntry) => EntryStatus.groupSyncId == entry.groupSyncId
			);

			if (findIndex >= 0) {
				state.requiredSyncEntriesStatusChecked.splice(findIndex, 1);
			}

			updateSyncEntry(state.syncEntries, entry);
			updateSyncEntry(state.syncEntriesFiltered, entry);
		});
	},
	setUserErrorMessage(state, error: string) {
		state.userErrorMessage = error;
	},
	setRequiredStatusCheck(state, syncEntries: ISyncEntry[]) {
		const sEntries = syncEntries.filter(
			(entry: ISyncEntry) =>
				state.requiredSyncEntriesStatusChecked.findIndex(
					(x: ISyncEntry) => x.groupSyncId == entry.groupSyncId
				) == -1 &&
				!entry.lastUpdated &&
				entry.enabled
		);
		state.requiredSyncEntriesStatusChecked.length > 1
			? state.requiredSyncEntriesStatusChecked.push(...syncEntries)
			: (state.requiredSyncEntriesStatusChecked = syncEntries);
	},
	setSyncEntryFilteredPageIndex(state, index: number) {
		state.syncEntryFilteredPageIndex = index;
	},
	setSyncEntryFilter(state, filter: string) {
		state.syncEntryFilter = filter;
	},
	resetQueriedSyncEntries(state) {
		state.syncEntriesFiltered = [];
	},
	setQueriedSyncEntries(state, syncEntries: ISyncEntry[]) {
		state.syncEntryFilteredPageIndex > 1
			? state.syncEntriesFiltered.push(...syncEntries)
			: (state.syncEntriesFiltered = syncEntries);
	},
	setSyncEntryPageSize(state, pageSize: number) {
		state.syncEntryPageSize = pageSize;
	},
	resyncSyncEntry(state, syncEntry: ISyncEntry) {
		let addedToRequiredSyncEntriesStatusChecked: boolean = false;

		const resyncSyncEntry = (syncEntries: ISyncEntry[]): void => {
			const stateSyncEntry = syncEntries.find((se: ISyncEntry) => se.groupSyncId == syncEntry.groupSyncId);
			if (stateSyncEntry) {
				stateSyncEntry.lastUpdated = null;

				// we only want to add this once so that it isn't checked multiple times on the server
				if (!addedToRequiredSyncEntriesStatusChecked) {
					state.requiredSyncEntriesStatusChecked.push(stateSyncEntry);
					addedToRequiredSyncEntriesStatusChecked = true;
				}
			}
		};

		resyncSyncEntry(state.syncEntries);
		resyncSyncEntry(state.syncEntriesFiltered);
	},
	resetState(state) {
		Object.assign(state, getDefaultState());
	}
};
